module.exports = __webpack_public_path__ + "static/media/lamar.bbdf9acd.jpg";